import { render, staticRenderFns } from "./productTags.vue?vue&type=template&id=3218bb63"
import script from "./productTags.vue?vue&type=script&lang=js"
export * from "./productTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports